import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import AssetUploader from '../widgets/AssetUploader';
import AssetBrowser from '../widgets/AssetBrowser';
import { CATEGORIES } from '../../services/fileUpload/uploadFile';
import { checkPermissions } from '../../../lib/utils';
import { ACCESS_POINTS_GROUP } from '../../constants/AccessPoints';

class PagesOther extends Component {
    onResetErrors = () => {
        this.browser && this.browser.resetErrors();
    };

    onRefresh = () => {
        this.browser && this.browser.refresh();
    };

    render() {
        const metadata = {
            category: CATEGORIES.OTHER
        };
        return (
            <div className="ThemeCalendar Theme-Content">
                <h1>Other files</h1>
                <hr />
                {this.props.children}
                <AssetBrowser
                    setRef={node => (this.browser = node)}
                    category={CATEGORIES.OTHER}
                    displayMode="grid"
                    hasAccessForDelete={this.props.hasAccessThemes.delete || this.props.hasAccessCustomContent.delete}
                >
                    <div className="col-xs-1">
                        <AssetUploader
                            onError={error => this.browser && this.browser.errorHandler(error)}
                            hasAccess={this.props.hasAccessThemes.add || this.props.hasAccessCustomContent.add}
                            onResetErrors={this.onResetErrors}
                            onRefresh={this.onRefresh}
                            onOpen={this.onResetErrors}
                            metadata={metadata}
                        />
                    </div>
                </AssetBrowser>
            </div>
        );
    }
}

PagesOther.propTypes = {
    children: PropTypes.element
};

const mapStateToProps = state => {
    return {
        hasAccessThemes: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        hasAccessCustomContent: checkPermissions(state, ACCESS_POINTS_GROUP.CUSTOM_CONTENT)
    };
};

export default connect(mapStateToProps)(PagesOther);



// WEBPACK FOOTER //
// ./src/components/assets/PagesOther.js